import PropTypes from 'prop-types';

import styles from './_index.module.scss';

const NarrativeLoadingDots = ({ topics }) => {
  return (
    <div className={styles['narrative-loading-dots']}>
      {topics.map((topic, index) => {
        return (
          <div
            className={`${styles['narrative-loading-dot']} ${topic.status === 'COMPLETED' ? styles['is-complete'] : ''}`}
            key={index}
          />
        );
      })}
    </div>
  );
};

NarrativeLoadingDots.propTypes = {
  topics: PropTypes.array.isRequired,
};

export default NarrativeLoadingDots;
